import React from 'react';

import {
  Header,
  SearchLightText,
  SearchLightLogo
} from './Styled';

export const RegisterHeader = ({ step }) => {
  return (
    <Header>
      <SearchLightLogo />
      <SearchLightText />
    </Header>
  );
};

export default RegisterHeader;
